module.exports = __webpack_public_path__ + "img/Tripplanner.959ac6ea.svg";